// extracted by mini-css-extract-plugin
var _1 = "ApplicantCreditCheckVerdictModal-moduleApplicantCreditCheckVerdictModal__UyQGE";
var _2 = "ApplicantCreditCheckVerdictModal-moduledocument__13jdv";
var _3 = "ApplicantCreditCheckVerdictModal-moduledocumentLabel__A2jQQ";
var _4 = "ApplicantCreditCheckVerdictModal-moduleextractedChip__iv15l";
var _5 = "ApplicantCreditCheckVerdictModal-moduleextractedField__ryUkS";
var _6 = "ApplicantCreditCheckVerdictModal-moduleradio__JBZy4";
var _7 = "ApplicantCreditCheckVerdictModal-modulesuffix__ThbUD";
var _8 = "ApplicantCreditCheckVerdictModal-moduleverification__eo10Z";
export { _1 as "ApplicantCreditCheckVerdictModal", _2 as "document", _3 as "documentLabel", _4 as "extractedChip", _5 as "extractedField", _6 as "radio", _7 as "suffix", _8 as "verification" }
